export class PodcastLazyLoader {
    private index: number = 0;
    private showCount: number = 10;
    private episodes: HTMLElement[];

    constructor() {

        this.episodes = Array.from(document.querySelectorAll('.cwf-podcast-episode'));

        // What is the DOM index of this item?
        this.index = this.episodes.findIndex((episode) => episode.classList.contains('hidden'));

        // Add a scroll observer to ".load-boundary"
        const observer: IntersectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Load the podcast
                        this.showNextGroup(entry.target);
                    }
                });
            }
        );

        observer.observe(document.querySelector('.load-boundary') as Element);
    }

    showNextGroup(target: Element) {
        console.log("Show next group");

        const episodesToShow = this.episodes.slice(this.index, this.index + this.showCount);
        episodesToShow.forEach((episode) => {
            episode.classList.remove('hidden');
        });

        this.index += this.showCount;
    }
}
